import Header from "@commons/header";
import Column from "@components/column";
import Tab from "@components/tabs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Module } from "@apis/index";
import { RootState } from "@store/index";
import ProductListTable from "./ProductListTable";
import StoreSelectionModal from "./StoreSelectionModal";
import { useModal } from "@context/ModalContext";
import { useSearchParams } from "react-router-dom";
import ProductTasksTable from "./ProductTasksTable";

const ProductList = () => {
  const { data: modules } = useSelector((state: RootState) => state.modules);
  const { showModal } = useModal();
  const [searchParams] = useSearchParams();
  const moduleParam = searchParams.get("module");

  const activeModuleIndex = Array.isArray(modules)
    ? modules.findIndex(
        (m) => m.name.toLowerCase() === moduleParam?.toLowerCase()
      )
    : -1;
  const safeActiveIndex = activeModuleIndex === -1 ? 0 : activeModuleIndex;

  const fetchModules = async () => {
    await Module.list({ state: "modules", params: { isActive: true } });
  };

  useEffect(() => {
    fetchModules();
  }, []);

  const items = Array.isArray(modules)
    ? modules.map((module) => ({
        label: module.name,
        component: ProductListTable,
        props: { moduleId: module.id, key: module.id },
      }))
    : [];

  const handleAddProduct = () => {
    if (Array.isArray(modules) && modules[safeActiveIndex]) {
      const activeModule = modules[safeActiveIndex];
      showModal(
        <StoreSelectionModal
          moduleId={activeModule.id}
          moduleName={activeModule.name}
        />,
        { width: 1500 }
      );
    }
  };

  return (
    <Column>
      <Header
        title="Product List"
        hasButton={true}
        btnTitle={"Add Product"}
        onClick={handleAddProduct}
      />
      {items.length > 0 && (
        <Tab
          items={items}
          fitContent
          paramKey="module"
        />
      )}
    </Column>
  );
};

export default ProductList;
